import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';
import { formatDateTime } from '../../../lib/dateUtils';
import { API_URL, auth, errMsg } from '../financeApi';

const ACTION = {
  recorded: 'Payment recorded', corrected: 'Payment corrected', fee_set: 'Monthly fee changed',
  fee_override: 'One-month fee', fee_override_removed: 'One-month fee removed',
};

export const PaymentLogDialog = ({ open, onClose, token }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!open) return;
    setRows(null);
    axios.get(`${API_URL}/finance/parent-payments/log`, auth(token))
      .then((r) => setRows(r.data))
      .catch((e) => toast.error(errMsg(e, 'Could not load the log')));
  }, [open, token]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="payment-log-dialog">
        <DialogHeader>
          <DialogTitle>Payment change log</DialogTitle>
          <DialogDescription>Every payment and fee change by you and your drivers, newest first.</DialogDescription>
        </DialogHeader>
        {!rows && <p className="text-sm text-muted-foreground">Loading…</p>}
        {rows && rows.length === 0 && <p className="text-sm text-muted-foreground" data-testid="payment-log-empty">No changes yet.</p>}
        <ul className="space-y-2">
          {rows?.map((r) => (
            <li key={r.log_id} className="border rounded-lg p-3 text-sm" data-testid={`payment-log-${r.log_id}`}>
              <div className="flex flex-wrap justify-between gap-2">
                <span className="font-semibold">{r.kid_name} · {ACTION[r.action] || r.action}</span>
                <span className="text-xs text-muted-foreground">{formatDateTime(r.at)} · {r.by_name} ({r.by_role === 'driver' ? 'Driver' : 'Operator'})</span>
              </div>
              <p className="text-muted-foreground mt-0.5">{r.summary}</p>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
